export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchasing?',
    a: 'You receive digital access to the materials after completing your purchase. No shipping is required.',
  },
  {
    q: 'Who is Massage Therapist Ready for?',
    a: 'It is designed for massage therapists and bodywork professionals who want more structure, practical session ideas, visual professional references, and ready-to-use resources.',
  },
  {
    q: 'Does this work internationally?',
    a: 'The system is designed as a general professional massage education and session-planning resource. Scope of practice and regulations vary by location, so always follow applicable local requirements.',
  },
  {
    q: 'Do I need to edit anything before using it?',
    a: 'No. The resources are delivered as completed PDFs designed to be opened, read, printed, and used directly.',
  },
  {
    q: 'Can I edit the PDFs?',
    a: 'No. The package is provided as finished PDF material, not editable Word documents or templates.',
  },
  {
    q: 'Is this a massage certification?',
    a: 'No. Massage Therapist Ready is an educational and professional resource system. It does not replace required professional education, certification, or licensing where applicable.',
  },
  {
    q: 'What format are the materials in?',
    a: 'PDF.',
  },
  {
    q: 'Are videos included?',
    a: 'No. The package focuses on the complete PDF system, professional visual references, session structures, and practical guides.',
  },
  {
    q: 'Are all 150 sessions the same?',
    a: 'No. The library includes different body regions, goals, durations, pressure considerations, client contexts, and professional approaches.',
  },
  {
    q: 'Does the material diagnose or treat medical conditions?',
    a: 'No. Massage Therapist Ready is designed for professional massage education and session planning within massage therapy scope. It does not provide medical diagnoses or replace appropriate healthcare evaluation.',
  },
  {
    q: "What if it isn't right for me?",
    a: 'You have a 7-day money-back guarantee.',
  },
]
